module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAmCAYAAAC29NkdAAAA30lEQVRYR+3WMQ6FIBBF0XEr9FY0bJgFWFnRuwQrt0BFg4U/mJhYM+8Z8jP0mOMFwSnGeMnAYzKgcnWsoDKgWEErqC0wz7Ps+y7neXY9iroHQwjinJOcs6zrOhbwwTXVtm1yHMc4QBSuvRF8iZE4OLDttwbULut7L8AKMnCwgiwcBMjEqYFsnAr4BU4FfI6TWquklO7bgjFUX/EXSBWwFWMj1UA2EgJkImFAFhIKZCDhQDSSAkQiacA3spQiy7J0neNUYBN57+/f/d6bhg7syvaaZEArqC2gnW978O8L/gCwGA6K0GzUSQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prev.png
// module id = gtHh
// module chunks = 1